<template>
    <modal name="lookbook-item-modal" class="item-modal dgm-modal"
           :width="'80%'"
           :height="'80%'"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <div class="lookbook_item_wrap">
            <div class="li_title">상품등록</div>
            <button class="close_btn" @click="modalClose"></button>
            <elastic-list-component :elasticType="'lookbookItem'"></elastic-list-component>
        </div>
    </modal>

</template>

<script>
import elasticList from '@/mixins/elastic/elasticList.js'
import ElasticListComponent from "@/components/elastic/ElasticListComponent";
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";

export default {
    name: 'LookbookItemModal',
    props: {},
    mixins: [elasticList],
    components: {ElasticListComponent},
    computed: {},
    provide() {
        return {
            selectModalData: this.selectData,
            checkItem: this.checkItem
        }
    },
    data() {
        return {
            itemData: [],
            itemIndex: '',
        }
    },
    mounted() {

    },
    methods: {
        handlerBeforeOpen(event) {
            if (!util.isEmpty(event.params) && !util.isEmpty(event.params.itemData)) {
                this.itemData = event.params.itemData;
            }
            if (!util.isEmpty(event.params) && !util.isEmpty(event.params.itemIndex)) {
                this.itemIndex = event.params.itemIndex;
            }

        },
        handlerOpened() {
        },
        handlerBeforeClose() {
            this.itemData = [];
            this.$router.replace(this.$route.path);
        },
        modalClose() {
            this.$modal.hide('lookbook-item-modal');
        },
        checkItem(data) {
            let itemIndex = this.itemData.findIndex(item => item.key === data.i_idx);
            return itemIndex > -1;
        },
        selectData(data) {
            let item = {
                link: data.itemImage[0].org_url,
                title: data.i_name,
                key: data.i_idx,
                time: '00:00:00',
            }
            EventBus.$emit('selectLookbookItem', item, this.itemIndex);
            this.modalClose();
        },

    }
}
</script>
